const {
  configJson,
  prettyPlayerUrl,
  prettyTeamUrl,
  prettyLiveHubUrl,
} = require('../rcs_gaz_mc_core_FE');

class ConfigManager {
  static getEnv() {
    configJson.urlToUse = process.env.REACT_APP_ENV;
    return process.env.REACT_APP_ENV;
  }

  static getEndPointsArticles() {
    return configJson.endpoints.articles;
  }

  static getBettingEndpoint() {
    return configJson.endpoints.bet;
  }

  static getProbabiliEndpoint() {
    return configJson.endpoints.probabiliMethode;
  }

  static getContextRoot() {
    return configJson.endpoints[this.getEnv()];
  }

  static getServiceInfo(group, serviceName) {
    return configJson.serviceCollection[group][serviceName];
  }

  static getApiVersion() {
    return configJson.apiVersion;
  }

  static getConstants() {
    return configJson.constants;
  }

  static buildUrl(contextRoot, apiName, urlParameters) {
    urlParameters.version = this.getApiVersion();
    return `${contextRoot}${apiName(urlParameters)}`;
  }

  static getSportRefreshInterval(sportId) {
    return configJson.sportRefreshInterval[sportId];
  }

  static getLanguageDictionary() {
    return configJson.dictionary[configJson.language];
  }

  static getRoute(routeName) {
    const routeObject = configJson.routes[routeName];
    return routeObject[this.getEnv()]();
  }

  static getColsOrder(tableName) {
    return configJson.tables.colsPosition[tableName];
  }

  static getJoinedCols(tableName) {
    return configJson.tables.joinedCols[tableName];
  }

  static getPositionMarker() {
    return configJson.tables.positionMarker;
  }

  static getSkipCols(tableName) {
    return configJson.tables.skipCols[tableName];
  }

  static getWidgetColsOrder(tableName) {
    return configJson.widgets.colsPosition[tableName];
  }

  static getWidgetJoinedCols(tableName) {
    return configJson.widgets.joinedCols[tableName];
  }

  static getWidgetPositionMarker() {
    return configJson.widgets.positionMarker;
  }

  static getWidgetSkipCols(tableName) {
    return configJson.widgets.skipCols[tableName];
  }

  static getPlayerUrl(playerName, playerId, sportId, site) {
    return prettyPlayerUrl(playerName, playerId, sportId, site);
  }

  static getFootballTeams(res) {
    return configJson.imageUrls.football.teams[res];
  }

  static getCountriesFlag() {
    return configJson.imageUrls.countriesFlag;
  }

  static getFootballPlayers() {
    return configJson.imageUrls.football.players;
  }

  static prettyTeamUrl(sportId, competitionId, site, team) {
    return prettyTeamUrl(sportId, competitionId, site, team);
  }

  static prettyLiveHubUrl(site) {
    return prettyLiveHubUrl(site);
  }

  static getTabbarTabsCup(tableName, competitionId) {
    if (Number(competitionId) !== 4) {
      return configJson.tables.tableTabbar[tableName];
    }
    return configJson.tables.tableTabbar[competitionId];
  }

  static getMotorSportConstructor() {
    return configJson.imageUrls.teams;
  }

  static getMotorCircuit() {
    return configJson.imageUrls.circuits;
  }

  static getRugbyTeams(res) {
    return configJson.imageUrls.rugby.teams[res];
  }
}

export default ConfigManager;



// WEBPACK FOOTER //
// ./src/common/configManager/configManager.js